<template>
  <label class="ap-checkbox">
    <span class="ap-checkbox__label">{{ label }}</span>
    <input
      type="checkbox"
      :checked="isChecked"
      :value="value"
      @change="updateInput"
    />
    <ap-checkbox-check-icon v-show="isChecked" class="ap-checkbox__checkmark" />
  </label>
</template>

<script>
import ApCheckboxCheckIcon from "@/components/artek/icons/ap-checkbox-check-icon";
export default {
  name: "ap-checkbox",
  components: { ApCheckboxCheckIcon },
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    value: { type: String, default: "" },
    modelValue: { type: [Boolean, Array], default: false },
    label: { type: String, required: true },
    trueValue: { type: Boolean, default: true },
    falseValue: { type: Boolean, default: false }
  },
  computed: {
    isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value);
      }
      return this.modelValue === this.trueValue;
    }
  },
  methods: {
    updateInput(event) {
      const isChecked = event.target.checked;
      if (this.modelValue instanceof Array) {
        const newValue = [...this.modelValue];

        if (isChecked) {
          newValue.push(this.value);
        } else {
          newValue.splice(newValue.indexOf(this.value), 1);
        }

        this.$emit("change", newValue);
      } else {
        this.$emit("change", isChecked ? this.trueValue : this.falseValue);
      }
    }
  }
};
</script>
